import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from 'src/app/core/services/spinner.service';
import { IntelexSupplierAuditService } from 'src/app/shared/service/intelex-supplier-audit.service';

@Component({
  selector: 'app-search-sso',
  templateUrl: './search-sso.component.html',
  styleUrls: ['./search-sso.component.scss']
})
export class IntelexSupplierAuditSSOComponent implements OnInit {
  regiForm: FormGroup;
  listSSO: any[] = [];

  constructor(
    private spinner: Spinner,
    private fb: FormBuilder,
    private service: IntelexSupplierAuditService,
    private toastService: ToastrService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<IntelexSupplierAuditSSOComponent>) { }

  onConfirmClick(): void {
    this.dialogRef.close({
      name: `${this.regiForm.value.ssoID
        ? this.upperCaseFirstLetter(this.regiForm.value.ssoID.firstName) + ' ' + this.upperCaseFirstLetter(this.regiForm.value.ssoID.lastName) : ''}`,
        sso: this.regiForm.value.ssoID ? this.regiForm.value.ssoID.sso : '',
        email: this.regiForm.value.ssoID ? this.regiForm.value.ssoID.email : ''
    }
      );
  }

  ngOnInit() {
    this.initForm();
    this.regiForm.controls['email'].valueChanges.subscribe(res => {
      if (res.length > 0) {
        this.regiForm.controls['firstName'].clearValidators();
        this.regiForm.controls['lastName'].clearValidators();
      } else {
        this.regiForm.controls['firstName'].setValidators(Validators.required);
        this.regiForm.controls['lastName'].setValidators(Validators.required);
      }
      this.regiForm.get('firstName').updateValueAndValidity();
      this.regiForm.get('lastName').updateValueAndValidity();
      this.regiForm.updateValueAndValidity();
    });
  }

  initForm() {
    return this.regiForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      ssoID: [],
      email: [''],
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitForm(): void {
    if (!this.regiForm.valid) {
      this.markFormGroupTouched(this.regiForm);
      return;
    } else {
      const body = this.regiForm.getRawValue();
      this.spinner.show();
      this.service.getSSOList(body).subscribe((res) => {
        this.spinner.hide();
        this.listSSO = res.data;
        if (!res.data.length) {
          this.toastService.error('Not found SSO ID');
        }
      }, (err) => {
        this.spinner.hide();
        this.toastService.error('Not found SSO ID');
      });
    }
  }

  selectSSOID(): void {
    this.onConfirmClick();
  }

  upperCaseFirstLetter(name) {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

}
